<!-- wizard-builder.component.html -->
<div class="wizard-page">
  <mat-card class="wizard-card">

    <mat-card-header class="wizard-card-header">
      <mat-card-title>Create a {{ resourceName }}</mat-card-title>
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content class="wizard-body">
      <div class="wizard-layout">

        <!-- Step list -->
        <div class="wizard-steps" *ngIf="plugins.length > 0">
          <div
            *ngFor="let plugin of plugins; let i = index"
            class="step-item"
            [class.step-active]="currentPluginIndex === i"
            [class.step-done]="currentPluginIndex > i"
            [matTooltip]="plugin.config.description"
            matTooltipPosition="right"
            (click)="goToPlugin(i)">
            <div class="step-bubble">
              <mat-icon *ngIf="currentPluginIndex > i" class="step-check">check</mat-icon>
              <span *ngIf="currentPluginIndex <= i">{{ i + 1 }}</span>
            </div>
            <span class="step-name">{{ plugin.config.name }}</span>
          </div>
        </div>

        <mat-divider vertical class="wizard-divider"></mat-divider>

        <!-- Plugin content -->
        <div class="wizard-content">
          <div appComponentHost #pluginHost="appComponentHost"></div>

          <div class="wizard-nav">
            <button mat-stroked-button color="primary"
              *ngIf="canGoPrevious()" (click)="previousStep()">
              <mat-icon>chevron_left</mat-icon> Back
            </button>
            <span class="nav-spacer"></span>
            <button mat-raised-button color="primary"
              *ngIf="canGoNext()" (click)="nextStep()">
              Save &amp; Proceed <mat-icon>chevron_right</mat-icon>
            </button>
            <button [title]="finishButtonToolTip" mat-raised-button color="primary"
              *ngIf="!canGoNext()" (click)="finishWizard()">
              {{ finishButtonName }} <mat-icon>check</mat-icon>
            </button>
            <button title="Save and Forward" mat-raised-button color="accent"
              *ngIf="!canGoNext() && showSaveAndForwardButton" (click)="finishWizard('Forward')">
              Save and Forward <mat-icon>forward</mat-icon>
            </button>
          </div>
        </div>

        <!-- Preview sidebar -->
        <div class="wizard-preview" *ngIf="hasPluginData()">
          <div class="preview-header">
            <img *ngIf="resourceConfig?.type"
              src="../../../assets/images/resources/resource/{{ resourceConfig!.type }}.svg"
              class="preview-resource-icon" alt="{{ resourceName }}">
            <span class="preview-title">{{ resourceName }} Preview</span>
          </div>
          <div class="preview-container">
            <ng-container *ngFor="let plugin of plugins; let i = index">
              <div *ngIf="hasPluginDataForIndex(i)" class="plugin-preview-section">
                <div appComponentHost #previewHost="appComponentHost"></div>
              </div>
            </ng-container>
          </div>
        </div>

      </div>
    </mat-card-content>

  </mat-card>
</div>

<app-forward-requisition
  *ngIf="showForwardPopup"
  [requisitionId]="selectedRequisitionId"
  [redirectNavigationUrl]="redirectNavigationUrl"
  [selectedRequisition]="selectedRequisition"
  (closed)="showForwardPopup=false"
  (forwarded)="onForwarded($event)">
</app-forward-requisition>
